"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = prop;
const Druid_1 = require("../../Druid");
/**
 * HTML property value binding. Reading settings from html template
 *
 * HTML:
 * <div data-view="ExampleView" data-example-id="20">
 *
 * Typescript:
 * class ExampleView extends View {
 *     @prop exampleId: number = 0;
 * }
 *
 * The property will be available after the "mounted()" function is called
 */
function prop(target, propertyName) {
    Druid_1.default.getViewFramework().registerPropertyDecorator(target, propertyName);
}
//# sourceMappingURL=Prop.js.map